module.exports = __webpack_public_path__ + "img/7.31f4246c.png";